import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { AdminService } from 'src/app/admin/admin.service';
import {
    loadTicketEmailSettings,
    loadTicketEmailSettingsFailure,
    loadTicketEmailSettingsSuccess,
    saveTicketEmailSettings,
    saveTicketEmailSettingsFailure,
    saveTicketEmailSettingsSuccess
} from 'src/app/root-store/tickets-store/actions/ticket-email-settings.actions';
import { TicketEmailSettingsState } from 'src/app/root-store/tickets-store/state/ticket-email-settings.state';
import { showToasterMessage } from 'src/app/shared/actions/toaster.actions';

@Injectable()
export class TicketEmailSettingsEffects {
    constructor(
        private readonly _actions$: Actions,
        private readonly _adminService: AdminService,
        private readonly _store: Store<TicketEmailSettingsState>
    ) {}

    getEmailNotificationSettings$ = createEffect(() =>
        this._actions$.pipe(
            ofType(loadTicketEmailSettings),
            switchMap(() => {
                return this._adminService.getEmailSettings().pipe(
                    map((result) => loadTicketEmailSettingsSuccess({ settings: result })),
                    catchError((result) => of(loadTicketEmailSettingsFailure({ error: result })))
                );
            })
        )
    );

    saveEmailNotificationSettings$ = createEffect(() =>
        this._actions$.pipe(
            ofType(saveTicketEmailSettings),
            switchMap((action) => {
                return this._adminService.saveEmailSettings(action.settings).pipe(
                    map((result) => saveTicketEmailSettingsSuccess({ settings: [] })),
                    catchError((error) => of(saveTicketEmailSettingsFailure({ error: error })))
                );
            })
        )
    );

    showSaveSuccessMessage$ = createEffect(
        () =>
            this._actions$.pipe(
                ofType(saveTicketEmailSettingsSuccess),
                map(() => {
                    this._store.dispatch(
                        showToasterMessage({
                            message: 'Saved email setting successfully'
                        })
                    );
                })
            ),
        { dispatch: false }
    );
}
